/* global Excel */

export function getSafeSheetName(name) {
  return String(name || "Project")
    .replace(/[:\\/?*\[\]]/g, "_")
    .slice(0, 31);
}

const TEXT_FORMAT = "@";
const CODE_HEADER_PATTERN = /code|display_id/i;

// Excel auto-parses values like "1-11-14" or "06-01-001" as dates; text format must be set before writing values
export function formatCodeColumnsAsText(sheet, headers, totalRows) {
  if (!headers.length) return;
  sheet.getRangeByIndexes(0, 0, 1, headers.length).numberFormat = [headers.map(() => TEXT_FORMAT)];
  if (totalRows < 2) return;
  const bodyFormat = Array.from({ length: totalRows - 1 }, () => [TEXT_FORMAT]);
  headers.forEach((header, col) => {
    if (CODE_HEADER_PATTERN.test(String(header))) {
      sheet.getRangeByIndexes(1, col, totalRows - 1, 1).numberFormat = bodyFormat;
    }
  });
}
